<template>
  <Select
    :placeholder="placeholder"
    filterable
    clearable
    :multiple="multiple"
    :value.sync="value"
    @on-change="change"
  >
    <Option
      v-for="item in items"
      :key="item.id"
      :value="item.id"
      :label="item.title"
    >
      {{ item.title }}
    </Option>
  </Select>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Model from "@/models/admin/artshow";

@Component({
  props: {
    placeholder: {
      type: String,
      default: "请选择画展"
    },
    value: {
      type: [String, Number],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    }
  }
})
export default class ArtshowSelect extends Vue {
  items = [];

  async created() {
    this.items = await this.getList();
  }

  async getList() {
    const {
      data: { items }
    } = await new Model().GET({ query: {} });

    return items;
  }

  change(value) {
    this.$emit("change", value);
  }
}
</script>
